import { createStackNavigator } from '@react-navigation/stack';
import OrganizationDisabled from '_/space-management/screens/OrganizationDisabled';
import React from 'react';

import { AppRoute } from './types';
const OrganizationDisabledStack = createStackNavigator();

export default function OrganizationDisabledStackScreen() {
  return (
    <OrganizationDisabledStack.Navigator
      screenOptions={{ animationEnabled: true, headerShown: false }}
    >
      <OrganizationDisabledStack.Screen
        name={AppRoute.ORGANIZATION_DISABLED}
        component={OrganizationDisabled}
      />
    </OrganizationDisabledStack.Navigator>
  );
}
